export default {
  no_storefront_found: {
    title: 'Aucune vitrine trouvée',
    description: 'Veuillez créer une vitrine.',
  },
};
